import { Component, HostListener, OnInit, } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationService, ProfileService, EnquiryService, DocumentStatus, NotificationKeys, ResponseStatus, fileTypes, fileUploadStatus } from "@core";
import { TranslateService } from "@ngx-translate/core";
import { NzUploadFile } from "ng-zorro-antd/upload";
import { Observable, Observer, Subscription } from "rxjs";
import { pageRoutes } from "src/app/core/config/page-routes.config";
@Component({
    selector: "app-enquiry",
    templateUrl: "./enquiry.component.html",
    styleUrls: ["./enquiry.component.less"],
    standalone: false
})
export class EnquiryComponent implements OnInit {
  searchForm!: FormGroup;
  currentDate: any = new Date().toISOString().split("T")[0];
  categories: any;
  userTickets: any[] = [];
  loading: boolean = false;
  datePlacerholder: any = new Date();
  date = null;
  ticket_id: string | null = "";
  routeObs!: Subscription;
  newActivity: boolean = false;
  subjectLength!: number;
  notificationKeys = NotificationKeys;

  uploadForm!: FormGroup;
  uploadDocumentsModal: boolean = false;
  docToUpload: any;
  documentFiles: any;
  uploading: boolean = false;
  systemWidth!: number;
  
  constructor(
    private profileService: ProfileService,
    private route: ActivatedRoute,
    private enquiryService: EnquiryService,
    private router: Router,
    private notify: NotificationService,
    private fb: FormBuilder,
    private translate: TranslateService,
  ) {
    this.ticket_id = this.route.snapshot.paramMap.get("id");
    this.searchForm = this.fb.group({
      search: [""],
    });
    this.uploadForm = this.fb.group({
      documentFiles: this.fb.array([], Validators.required)
    })
    this.loadDocuments();
  // this.addDocumentFormControls();
  }


  setDocument(doc: any) {
    this.docToUpload = doc;
  }


preDocumentsUpload = (file: NzUploadFile): Observable<boolean> => 
    new Observable((observer: Observer<boolean>) => {
      const isJpgOrPng =
      file.type === fileTypes.JPG || file.type === fileTypes.PNG;
      if (!isJpgOrPng) {
        this.notify.error(
          "",
          this.translate.instant("ENQUIRY.FILE_FORMAT_ERROR"),
          this.notificationKeys.CERTIFICATE
        );
      observer.complete();
      this.uploading = false;
      }
      const isLt2M = file.size! / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.notify.error("", this.translate.instant("ENQUIRY.FILE_SIZE_ERROR"), this.notificationKeys.CERTIFICATE);
        observer.complete();
      }
      


      switch(this.docToUpload) {
        case "birthCert":
          this.documentsRequired[this.getIndex('birthCert')].fileList.push(file);
          break;
        case "changeOfName":
          this.documentsRequired[this.getIndex('changeOfName')].fileList.push(file);
          break;
        case "marriageCert":
          this.documentsRequired[this.getIndex('marriageCert')].fileList.push(file);
          break;
        default: 
          break;
      }
      observer.complete();
    })

    getIndex(val:any) {
      const index = this.documentsRequired.findIndex((obj:any) => obj.formControlName === val);
      return index;
    }


  documentsRequired: any[] = [];
  documentsList: NzUploadFile[] = [];

  loadDocuments() {
    this.documentsRequired = [
    {
      title: this.translate.instant("ENQUIRY.BIRTH_CERTIFICATE"),
      formControlName: 'birthCert',
      fileList: [],
      errorState: false,
      status: fileUploadStatus.PENDING
    },
    {
      title: this.translate.instant("ENQUIRY.CHANGE_OF_NAME_DOCUMENT"),
      formControlName: 'changeOfName', 
      fileList: [],
      errorState: false,
      status: fileUploadStatus.PENDING
    }, 
    {
      title: this.translate.instant("ENQUIRY.MARRIAGE_CERTIFICATE"),
      formControlName: 'marriageCert',
      fileList: [],
      errorState: false,
      status: fileUploadStatus.PENDING
    }
  ]
  }

  // QueryParam
  qparams: {
    start_date: string;
    end_date: string;
    search: string;
  } = {
    start_date: new Date().toISOString().split("T")[0],
    end_date: new Date().toISOString().split("T")[0],
    search: "",
  };

  //PAGINATION
  current_page: number = 0;
  total: number = 0;
  from: number = 0;
  to: number = 0;
  lastpage: number = 0;
  pageSize: number = 0;
  pageCount: number = 0;
  page: any[] = [];
  meta: any;
  nextPage: string = "";
  paginator = 0;
  tempName = null;

  get user(): any {
    return this.profileService.getLocalStorageUser();
  }



  getSystemWidth() {
    this.systemWidth = window.innerWidth;
    this.systemWidth > 576 ? this.subjectLength = 100 : this.subjectLength = 30
  }

  @HostListener('window: resize', ['$event'])
  onResize() {
    this.getSystemWidth();
  }

  ngOnInit(): void {
    this.getSystemWidth();
    this.getCategories();
    this.checkIfParamsExists();
  }

  openTicket() {
    this.router.navigate([pageRoutes.enquiry.openTicket]);
  }

  showTotal() {
    return `<div>
					<button>{{'GENERAL.EXPORT' | translate}}</button>
				</div>`;
  }

  getCategories() {
    this.enquiryService
      .listCategories()
      .then((res) => {
        this.categories = res?.data.data;
      })
      .catch((err) => {
        console.warn(err);
      });
  }

  checkIfParamsExists() {
    this.routeObs = this.route.queryParams.subscribe((params: any) => {
      if (Object.keys(params).length > 0) {
        this.getUserTickets(params);
      } else {
        this.getUserTickets();
      }
    });
  }

  getUserTickets(qparams?: any) {
    this.loading = true;
    this.enquiryService
      .listUserTickets(qparams)
      .then((res: any) => {
        if (res?.status === ResponseStatus.OK) {
          this.userTickets = res?.data?.data;
          const {
            current_page,
            last_page,
            total,
            per_page,
            count,
          } = res?.data?.pagination;
          this.current_page = current_page;
          this.pageCount = count;
          this.lastpage = last_page;
          this.from = current_page;
          this.to = (current_page - 1) * per_page + count;
          this.pageSize = per_page;
          this.total = total;
          this.loading = false;
        }
      })
      .catch((err: any) => {
        console.error(err?.error?.message);
      });
  }

  onSearch() {
    let queryParams = `?search=${this.searchForm.value.search}`;
    this.getUserTickets(queryParams);
  }

  onFilterByDate(date: any) {
    this.qparams.start_date = date[0].toISOString().split("T")[0];
    this.qparams.end_date = date[1].toISOString().split("T")[0];
    let queryParams = `?start_date=${this.qparams.start_date}&end_date=${this.qparams.end_date}`;
    this.getUserTickets(queryParams);
  }

  next(id: number): void {
    this.loading = true;
    let url = `?page=${id}`;
    this.enquiryService
      .listUserTickets(url)
      .then((res) => {
        if (res?.status === ResponseStatus.OK) {
          this.userTickets = res?.data?.data;
          const {
            current_page,
            last_page,
            total,
            per_page,
            count,
          } = res?.data?.pagination;
          this.current_page = current_page;
          this.pageCount = count;
          this.lastpage = last_page;
          this.from = current_page * per_page - per_page + 1;
          this.to = (current_page - 1) * per_page + count;
          this.pageSize = per_page;
          this.total = total;
          this.loading = false;
        }
      })
      .catch((err) => {
        console.error(err?.error?.message)
        this.loading = false;
      });
  }

  ngOnDestory() {
    this.routeObs.unsubscribe();
  }

  openUploadModal() {
    this.uploadDocumentsModal = true;
  }

  handleModalCancel() {
    // this.documentsRequired = [];
    this.resetFileLists();
    this.uploadDocumentsModal = false;
  }

  resetFileLists() {
    for(let file of this.documentsRequired) {
      file.fileList = [];
      file.status = fileUploadStatus.PENDING;
    }
  }

  addDocumentFormControls() {
    for (let i = 0; i < this.documentsRequired.length; i++) {
      this.documentFiles.push(this.fb.control(null));
    }
  }

  removeItem(file: NzUploadFile, controlIndex: number) {
    const control = this.documentsRequired[controlIndex];   
    const index = control.fileList.findIndex((item: any) => item.uid === file.uid);
    if(index !== -1) {
      control.fileList.splice(index, 1);
    }
   }

   disableSubmit: boolean = false;

   async submitDocuments() {
    this.disableSubmit = false;
    let documentsToSubmit = [];
    for(let entry of this.documentsRequired) {
      if(!entry.fileList.length) {
        this.notify.error('', this.translate.instant("ENQUIRY.KINDLY_UPLOAD") + " " + entry.title);
        this.disableSubmit = true;
        break;
      }

      entry.status = fileUploadStatus.UPLOADING;

      await this.simulateApiCall(entry);

      entry.status = fileUploadStatus.UPLOADED;
      this.notify.success('', `${entry.title} ${this.translate.instant("ENQUIRY.UPLOADED_SUCCESSFULLY")}`);
      const doc = {
        title: entry?.title,
        files: entry?.fileList
      }
      documentsToSubmit.push(doc);
    }
    
   }


   async simulateApiCall(data: any) {
    return new Promise<void>((resolve, reject) => {
      setTimeout(() => {
        if(data.title !== this.translate.instant("ENQUIRY.MARRIAGE_CERTIFICATE")) {
          resolve();
        } else {
          data.status = fileUploadStatus.FAILED;
          reject();
        }
      }, 3000)
    })
   }

   docStatus: string = '';

   getDocumentStatus(val: any): string {
    let pending: boolean = false;
    let submitted: boolean = false;
    let approved: boolean = false;


    for(let data of val) {
      if(data?.status === DocumentStatus.REJECTED || data?.status === DocumentStatus.PENDING) {
        pending = true;
      } else if(data?.status === DocumentStatus.SUBMITTED) {
        this.docStatus = fileUploadStatus.SUBMIITED;
        submitted = true;
      } else if(data?.status === DocumentStatus.APPROVED) {
        this.docStatus = fileUploadStatus.APPROVED;
        approved = true;
      }
    }

    if(pending) {
      return fileUploadStatus.PENDING;
    } else if(!pending && submitted) {
      return fileUploadStatus.SUBMIITED;
    } else if(!pending && approved) {
      return '';
    } else if(!pending && submitted && approved) {
      return fileUploadStatus.SUBMIITED;
    } else if(pending && submitted && approved) {
      return fileUploadStatus.PENDING;
    } else if(!pending && !submitted && !approved) {
      return '';
    }

    return '';
   }
  }
